<div style="background-color: #FAFAFA;">
    <div fxLayout="column" fxLayoutGap="20px" style="margin:1% 1%;background-color: #FAFAFA;">
        <div fxLayout="row" class="page-header" fxLayoutAlign="start center" fxLayoutGap="10px">
            <label fxFlexOffset="1%" class="label-header">Verification Status:</label>
            <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center" *ngIf="merchantDetails?.status == 'PENDING_REVIEW'">
                <img src="assets/pendingRequest2-icon.svg">
                <label class="pending-status">Verification Pending</label>
            </div>
            <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center" *ngIf="merchantDetails?.status == 'ACTIVE'">
                <img src="assets/approved-icon.svg">
                <label class="approved-status">Approved</label>
            </div>
            <div fxLayout="row" fxLayoutGap="70px" >
                <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center" *ngIf="merchantDetails?.status == 'REJECTED'">
                    <img src="assets/rejected-icon.svg">
                    <label class="rejected-status">Rejected</label>
                </div>
                <div fxLayoutGap="10px" *ngIf="merchantDetails?.status == 'REJECTED'">
                    <label class="label-header">Reason for Rejection:</label>
                    <span class="reject-reason">{{merchantDetails?.status_reason}}</span>
                </div>
            </div>
        </div>
        <div fxLayout="row" fxLayoutGap="60px" fxLayoutAlign="start start">
            <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="center center">
                <img src="assets/business-legal-icon.svg">
                <label class="business-label">Business Legal name</label>
                
            </div>
            <div fxLayout="row" fxFlex="70" fxLayoutGap="30px">
                <div fxLayout="column" fxFlex="50" fxLayoutGap="35px" >
                    <div fxLayout="column"  class="verification-card" fxLayoutGap="5px">
                        <label class="label-header">Business Legal Name</label>
                        <span class="business-label">{{businessInfo?.name}}</span>
                    </div>
                    <div fxLayout="column" class="verification-card">
                        <label class="label-header">Documents Permitted (any one)</label>
                        <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="15px">
                            <ol class="business-list-label">
                                <li>GST Certificate</li>
                                <li>Udyog Aadhar (UID)</li>
                                <li>Registration Proof</li>
                                <li>Reglonal State Registration Certificate</li>
                                <li>Municipal Corporation Department Certificate/License</li>
            
                            </ol>
                        </div>
            
                    </div>
                </div>
                <div fxLayout="column" fxFlex="50" class="verification-card" >
                    <div style="background-color:#FAFAFA;padding:30px 10px;" *ngIf="nameDocuments?.length !== 0">
                        <div fxLayout="row" fxLayoutAlign="end center" >
                            <button class="preview-btn" (click)="openPreviewPopup('name')">
                                <img src="assets/preview-icon.svg">
                            </button>
                        </div>
                        <div id="carouselExampleControlsNoTouching1" class="carousel slide" data-bs-touch="false" data-bs-ride="false">
                            <div class="carousel-inner">
                                <div class="carousel-item text-center" *ngFor="let namedoc of nameDocuments;let i=index"
                                    [ngClass]="{'active':i==0}">
                                    <img [src]="namedoc.url" style="width:33%;" alt="...">
                                    <h6 style="padding-top: 30px;">File {{i+1}} / {{nameDocuments?.length}}</h6>
                                </div>
                
                            </div>
                            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControlsNoTouching1"
                                data-bs-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"> </span>
                                <span class="visually-hidden">Previous</span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControlsNoTouching1"
                                data-bs-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Next</span>
                            </button>
                        </div>
                    </div>
            
                </div>
            </div>
        </div>
        <div class="divider"></div>
        <div fxLayout="row" fxLayoutGap="90px" fxLayoutAlign="start start">
            <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="center center">
                <img src="assets/business-address-icon.svg">
                <label class="business-label">Business Address</label>
            </div>
            <div fxLayout="row" fxFlex="70" fxLayoutGap="30px">
            <div fxLayout="column" fxLayoutGap="35px" fxFlex="50" >
                <div fxLayout="column" fxFlex="25" class="verification-card" fxLayoutGap="5px">
                    <label class="label-header">Business Address</label>
                    <span class="business-address">{{businessInfo?.address_1}}, {{businessInfo?.address_2}},  {{businessInfo?.city}},  {{businessInfo?.state}},   {{businessInfo?.pincode}}</span>
                </div>
                <div fxLayout="column" class="verification-card">
                    <label class="label-header">Documents Permitted (any one)</label>
                    <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="15px">
                        <ol class="business-list-label">
                            <li>Utility bills</li>
                            <li>Business license and permits from local, state or central government with address</li>
                            <li>Bank account statement with address</li>
                            <li>PAN card</li>
                            <li>Shop establishment certificate</li>

                        </ol>
                    </div>

                </div>
            </div>
            <div fxLayout="column" class="verification-card" fxFlex="50">
                <div style="background-color:#FAFAFA;padding:30px 10px;" *ngIf="addressDocuments?.length !== 0">
                    <div fxLayout="row" fxLayoutAlign="end center" >
                        <button class="preview-btn" (click)="openPreviewPopup('business')">
                            <img src="assets/preview-icon.svg">
                        </button>
                    </div>
                    <div id="carouselExampleControlsNoTouching2" class="carousel slide" data-bs-touch="false" data-bs-ride="false">
                        <div class="carousel-inner">
                            <div class="carousel-item text-center" *ngFor="let doc of addressDocuments;let i=index"
                                [ngClass]="{'active':i==0}">
                                <img [src]="doc.url" style="width:33%" alt="..." >
                                <h6 style="padding-top: 30px;">File {{i+1}} / {{addressDocuments.length}}</h6>
                            </div>
            
                        </div>
                        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControlsNoTouching2"
                            data-bs-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"> </span>
                            <span class="visually-hidden">Previous</span>
                        </button>
                        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControlsNoTouching2"
                            data-bs-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Next</span>
                        </button>
                    </div>
                </div>
            
            </div>
        </div>
        </div>
        <div class="divider"></div>
     </div>
     <div fxLayout="row" fxLayoutAlign="space-between center" class="verification-card" style="margin:1% 10% 0% 21%;">
        <!-- *ngIf="merchantDetails?.status == 'PENDING_REVIEW'" -->
        <div fxLayout="row" fxLayoutAlign="start center">
            <label class="container checkbox-label"> I have verified the template’s name, picture and
                description
                <input type="checkbox" [checked]="checked" (click)="changeAgreeButton()">
                <span class="checkmark"></span>
            </label>
        </div>
        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px" fxlayoutGap="end center">
            <button type="button" class="approve-btn" fxFlex="30" fxLayoutAlign="center center"
            (click)="openApprovalPopup()" [disabled]="!checked">Approve</button>
            <!-- (click)="verifyKyc('ACTIVE')" [disabled]="!checked" -->
            <button type="button" class="reject-btn" fxFlex="30" fxLayoutAlign="center center"
            (click)="openRejectpopup()" [disabled]="!checked">Reject</button>
           
        </div>
    </div>

</div>